<div mat-dialog-content style="width: 500px">
  <div class="text-center">
    <div class="i-circle danger">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h4 class="color-default" [innerHtml]="text | translate" *ngIf="text"></h4>
  </div>
  <div [innerHtml]="subtext | safeHtml" *ngIf="subtext"></div>

  <form [formGroup]="form" class="form-horizontal modal-dialog-custom" *ngIf="showNotes">
    <div class="row">

      <!-- Campos Adicionais -->
      <div formArrayName="AdditionalFields">
        <div class="col-sm-12" *ngFor="let field of form.controls.AdditionalFields.controls; let i = index"
          [formGroupName]="i">
          <div class="form-group">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <mat-label>{{field.get('Label').value|translate}}</mat-label>
                <input matInput formControlName="Value" />
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Observações -->
      <div class="col-sm-12">
        <div class="form-group">
          <div class="col-sm-12">
            <mat-form-field class="full-width">
              <mat-label>{{'NOTES'|translate}}</mat-label>
              <textarea matInput formControlName="Notes" [rows]="10"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>
<div mat-dialog-actions>
  <div class="full-width text-right">
    <button type="button" class="btn btn-danger" title="{{'NO' | translate}}" (click)="close(false)">
      <i class="fas fa-times"></i>&nbsp;{{'NO' | translate}}
    </button>
    <button type="button" class="btn btn-success" title="{{'YES' | translate}}" (click)="close(true)">
      <i class="fas fa-check"></i>&nbsp;{{'YES' | translate}}
    </button>
  </div>
</div>